import {usePriceFormat} from "@/hooks/usePriceFormat";
import clsxm from "@/lib/clsxm";
import type {ReactNode} from "react";

const DottedPriceRow = ({
  className,
  currency,
  icon,
  label,
  labelClassName,
  showCurrency = true,
  showStar = false,
  value,
  valueClassName,
}: {
  className?: string;
  currency?: string;
  icon?: ReactNode;
  label: string;
  labelClassName?: string;
  showCurrency?: boolean;
  showStar?: boolean;
  value?: number | ReactNode | string | null;
  valueClassName?: string;
}) => {
  const formatPrice = usePriceFormat({currency, fractionDigits: 2});

  return (
    <div className={clsxm("flex items-end justify-between gap-2", className)}>
      <div className="flex items-center gap-1">
        {icon}
        <span className={clsxm("text-neutral-slate-grey text-xs leading-3", labelClassName)}>{label}</span>
      </div>
      <div className="border-neutral-grey-light-dark flex-1 border-b-[1.5px] border-dashed" />
      <span className={clsxm("text-xs leading-3 font-semibold", valueClassName)}>
        {showCurrency && typeof value === "number" ? formatPrice(value) : value}
        {showStar && "*"}
      </span>
    </div>
  );
};

export default DottedPriceRow;
